import ProjectCard from "@/components/ProjectCard"
import SectionHeading from "@/components/SectionHeading"
import { cleanString, cn } from "@/lib/utils"
import { createDataAttribute } from "next-sanity"

interface ProjectsGridProps {
	heading?: string
	projects: any
	documentId: string
	_key: string
}

export default function ProjectsGrid({heading, projects, documentId, _key}:ProjectsGridProps) {
	return (
		<div className="section px-site"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}>

			{heading && <div className="mb-section--sm mt-section--lg sm:text-center">
				<SectionHeading heading={heading || `Featured Projects`} label="View All" url="/projects" />
			</div>}

			<div className="site-grid gap-y-section--sm">

				{projects?.map((item, index) => (
					<div key={`${item?.project?.slug}_${index}`} className={cn(`col-span-full`, {
						"md:col-span-6 project-thumb--small" : cleanString(item?.aspectRatio) !== "16/9",
						"md:col-start-7" : (cleanString(item?.aspectRatio) !== "16/9" && cleanString(item?.align) === "right"),
						"md:mt-[20vw]" : item?.nudgeDown
					})}>
						<ProjectCard
							title={item?.project?.title}
							subtitle={item?.project?.disciplines?.slice(0, 4)?.map(discipline => discipline?.title).join(', ')}
							url={`/projects/${item?.project?.slug}`}
							aspect={item?.aspectRatio}
							image={(item?.overrideDefaultPreview && item?.previewOverride?.image) ? item?.previewOverride?.image : item?.project?.preview?.image}
							video={(item?.overrideDefaultPreview && item?.previewOverride?.video) ? item?.previewOverride?.video : item?.project?.preview?.video}
						/>
					</div>
				))}

			</div>

		</div>

	)
}